export const defaultFontSize = 12;
